/** Client-side jurisdiction inference when saving family profile (mirrors server). */

/** Guests / unknown PLZ: Stadt Zürich only for now. */
export const DEFAULT_HOLIDAY_JURISDICTION = "ch-zh-stadt-zuerich";
/** Other ZH 8xxx: canton public holidays until more Gemeinde packs exist. */
export const CANTON_ZH_JURISDICTION = "ch-zh";
export const STADT_ZUERICH_JURISDICTION = "ch-zh-stadt-zuerich";
export const STADT_ZUERICH_PLZ_MIN = 8000;
export const STADT_ZUERICH_PLZ_MAX = 8099;

/**
 * @param {string|null|undefined} postalCode
 * @returns {{ holidayJurisdiction: string, holidayJurisdictionSource: "inferred"|"default" }}
 */
export function inferHolidayJurisdictionFromPostalCode(postalCode) {
  const plz = String(postalCode || "").trim();
  if (/^\d{4}$/.test(plz)) {
    const num = Number(plz);
    if (num >= STADT_ZUERICH_PLZ_MIN && num <= STADT_ZUERICH_PLZ_MAX) {
      return {
        holidayJurisdiction: STADT_ZUERICH_JURISDICTION,
        holidayJurisdictionSource: "inferred",
      };
    }
    if (plz.startsWith("8")) {
      return {
        holidayJurisdiction: CANTON_ZH_JURISDICTION,
        holidayJurisdictionSource: "inferred",
      };
    }
  }
  return {
    holidayJurisdiction: DEFAULT_HOLIDAY_JURISDICTION,
    holidayJurisdictionSource: "default",
  };
}
